window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 749 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

(function(){
  'use strict';

  theme.Images = (function() {
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
      if (typeof images === 'string') {
        images = [images];
      }

      for (var i = 0; i < images.length; i++) {
        var image = images[i];
        this.loadImage(this.getSizedImageUrl(image, size));
      }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
      new Image().src = path;
    }

    /**
     * Swaps the src of an image for another OR returns the imageURL to the callback function
     * @param image
     * @param element
     * @param callback
     */
    function switchImage(image, element, callback) {
      var size = this.imageSize(element.src);
      var imageUrl = this.getSizedImageUrl(image.src, size);

      if (callback) {
        callback(imageUrl, image, element); // eslint-disable-line callback-return
      } else {
        element.src = imageUrl;
      }
    }

    /**
     * +++ Useful
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
      );

      if (match !== null) {
        if (match[2] !== undefined) {
          return match[1] + match[2];
        } else {
          return match[1];
        }
      } else {
        return null;
      }
    }

    /**
     * +++ Useful
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );

      if (match !== null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    return {
      preload: preload,
      loadImage: loadImage,
      switchImage: switchImage,
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  })();
  
  theme.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      $(document).off('focusin');
      $(document).on(eventsName.focusout, function() {
        $(document).off(eventsName.keydown);
      });
  
      $(document).on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        $(document).on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      $(document).off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      $(document).addClass('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },
  
    unlockMobileScrolling: function(namespace, element) {
      $(document).removeClass('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  // Keyboard modality helper: show focus treatments only after Tab navigation.
  document.addEventListener('keydown', function(evt) {
    if (evt.key === 'Tab') {
      document.documentElement.classList.add('tab-outline');
    }
  });

  document.addEventListener('pointerdown', function() {
    document.documentElement.classList.remove('tab-outline');
  });
  
  window.vimeoApiReady = function() {
    theme.config.vimeoLoading = true;
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }
  
  function checkIfVimeoIsReady() {
    var wait;
    var timeout;
  
    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function() {
        if (!Vimeo) {
          return;
        }
  
        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);
  
      timeout = setTimeout(function() {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });
  
    return deferred;
  }
  
  theme.VimeoPlayer = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    };
  
    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }
  
      this.setAsLoading();
  
      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function() {
        var args = defaults;
        args.id = this.videoId;
  
        this.videoPlayer = new Vimeo.Player(this.el, args);
  
        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },
  
      playerReady: function() {
        this.iframe = this.el.querySelector('iframe');
        this.iframe.setAttribute('tabindex', '-1');
  
        this.videoPlayer.setMuted(true);
  
        this.setAsLoaded();
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return VimeoPlayer;
  })();
  
  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 1,
        autoplay: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('cartNotification', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
  
      document.documentElement.classList.add(this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
      
      if(this.config.handle != '' && this.config.productId != ''){
        theme.productMediaSlide(this.config.handle, this.config.productId);
      }
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      $(window).on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        $(this.modal).on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      $(document).off('.modal');
  
      if (this.config.closeOffContentClick) {
        $(this.modal).off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.variantSelecter = function() {
    $('body').on('change', '.product-form__input input[type="radio"]', function(evt){
      var cell = $(this).data('target');
      var target = document.querySelector('.' + cell);
      var value = $(this).val();
      
      $(this).closest('.product-form__input').find('.form__label-detail').text(value);    
      $('.current-variant__title').text(value);      
      updateOptions(target);
      updateRadioOptions(target);
      updateMasterId(target);
      toggleAddButton(target, true, '', false);
      updatePickupAvailability(target);
      removeErrorMessage(target);
      //updateEstimatedate(target);

      if (!target.currentVariant) {
        toggleAddButton(target, true, '', true);
        setUnavailable(target);
      } else {
        updateMedia(target);
        updateURL(target);
        updateVariantInput(target);
        productImageZoom();
        renderProductInfo(target);
      }
    })

    function updateOptions(target) {
      target.options = Array.from(target.querySelectorAll('select'), (select) => select.value);
    }

    function updateMasterId(target) {
      target.currentVariant = getVariantData(target).find((variant) => {
        return !variant.options.map((option, index) => {
          return target.options[index] === option;
        }).includes(false);
      });
    }


    function updateMedia(target) {
      if (!target.currentVariant) return;
      if (!target.currentVariant.featured_media) return;

      var productId = target.dataset.productid;
      const mediaJson = document.querySelector(`#ImageJSON-${productId}`).innerHTML.trim();
      const variantImageMap = document.querySelector(`#VariantImageMap-${productId}`).innerHTML;
      var mediaSliderWrap = $(`.product__media-slider-${productId}`);
      var mediaThumbnailWrap = $(`.product__media-thumbnails-${productId}`);
      var mediaSlideGroup = '';
      var mediaThumbGroup = '';
      const badgeJson = document.querySelector(`#BadgeJSON-${target.currentVariant.id}`).innerHTML;
      var badgeAdded = false;

      if (!mediaJson) return;
      if (!target.currentVariant.option1) return;

      const medialistJson = JSON.parse(mediaJson);
      var badge = JSON.parse(badgeJson);
      
      /* 
        variant image map value is created in  product-media-wrap.liquid snippet and assumes the following:
          - all images grouped by product color variant
          - the first item in each group is the canonical variant image
      */
      const variantImageMapSanitized = variantImageMap.trim().split(',').map((value) => {
        const values = value.split('|');
        return {
          variantId: values[0],
          startIndex: parseInt(values[1]),
        }
      });

      const variantImageMapSorted = variantImageMapSanitized.sort((a, b) => a.startIndex - b.startIndex)

      variantImageMapSorted.forEach((value, index, array) => {
        if (array[index + 1]) {
          value.endIndex = array[index + 1].startIndex;
        } else {
          value.endIndex = medialistJson.length;
        }
      });

      if(medialistJson.length > 0){
        const currentVariantRange = variantImageMapSorted.find((variantRange) => variantRange.variantId == target.currentVariant.id);

        for(var i=0; i < medialistJson.length; i++){
          const media = medialistJson[i];

          var mediaSlideCell = '<div class="product__media-slider-cell">';
          var mediaSlideImgWrap = '<div class="product__media media media--transparent" style="padding-top: ' + 100 / media.preview_image.aspect_ratio + '%;">';
          var zoom_img_width = media.preview_image.width;
          var mediaSlideImg = `<img
            srcset="${theme.Images.getSizedImageUrl(media.preview_image.src, '750x')}"
            src="${theme.Images.getSizedImageUrl(media.preview_image.src, '1500x')}"
            sizes="(min-width: 1480px) 883px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)"
            loading="lazy"
            width="${media.preview_image.width}"
            height="${media.preview_image.height}"
            alt="${target.currentVariant.name.replace(/"/g, '')} View ${i}"
            class="image-zoom zoom-thumb"
            data-zoom="${theme.Images.getSizedImageUrl(media.preview_image.src, '750x')}"
          >`;
          
          if (media.media_type == 'external_video') {
            if (media.host == 'youtube') {
              // Use an empty <template> in the HTML string — jQuery's innerHTML parsing
              // does not reliably place content into template.content, which causes the
              // iframe to render immediately and show YouTube's play button alongside ours.
              // We populate template.content programmatically after DOM insertion instead.
              var videoEmbed =
                '<deferred-media class="deferred-media media no-js-hidden" style="padding-top: ' + (100 / media.preview_image.aspect_ratio) + '%" data-media-id="' + media.id + '" data-video-id="' + media.external_id + '">' +
                  '<button id="Deferred-Poster-Modal-' + media.id + '" class="deferred-media__poster" type="button">' +
                    '<span class="visually-hidden">Play video</span>' +
                    '<span class="deferred-media__poster-button motion-reduce">' +
                      '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" fill="none" viewBox="0 0 10 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.9910 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"/></svg>' +
                    '</span>' +
                    '<img src="' + theme.Images.getSizedImageUrl(media.preview_image.src, '1500x') + '" alt="' + target.currentVariant.name.replace(/"/g, '') + '" width="' + media.preview_image.width + '" height="' + media.preview_image.height + '" loading="lazy">' +
                  '</button>' +
                  '<template></template>' +
                '</deferred-media>';
            }
          }

          var mediaThumbCell = '<div class="product__media-thumbnail-cell">';
          var mediaThumbImgWrap = '<div class="product__thumb-item">';
          var mediaThumbImg = `<img src="${theme.Images.getSizedImageUrl(media.preview_image.src, '65x')}" alt="${target.currentVariant.name.replace(/"/g, '')} View ${i}"  width="65" height="${65 / media.preview_image.aspect_ratio}" />`;

          if (i >= currentVariantRange.startIndex && i < currentVariantRange.endIndex) {
            mediaSlideGroup += mediaSlideCell;
            var mediaBadgeUrl = "";
            var mediaThumbBadge = "";
            if (badge.badge_icon_url != "") {
              mediaBadgeUrl = badge.badge_icon_url;
              var mediaBadgeAlt = (badge.badge_icon_alt == "") ? mediaBadgeUrl : badge.badge_icon_alt;
              mediaThumbBadge = `<img src='${mediaBadgeUrl}' class='product__media-slider-badge' alt='${mediaBadgeAlt}'>`
              if (mediaThumbBadge != "" && !badgeAdded) {
                mediaSlideGroup += mediaThumbBadge;
                badgeAdded = true;
              }
            }
            if (media.media_type == 'image') {
              mediaSlideGroup += mediaSlideImgWrap;
              mediaSlideGroup += mediaSlideImg;
              mediaSlideGroup += '</div>';
            }
            if (media.media_type == 'external_video') {
              mediaSlideGroup += videoEmbed;
            }
            mediaSlideGroup += '</div>';

            mediaThumbGroup += mediaThumbCell;
            mediaThumbGroup += mediaThumbImgWrap;
            mediaThumbGroup += mediaThumbImg;
            mediaThumbGroup += '</div></div>';
          }
        }

        var isV2 = $('body').hasClass('v2-template');

        // Thumbnails must be initialized BEFORE the main slider. If the main slider
        // runs first, Slick's asNavFor auto-inits the thumbnails with default settings,
        // then our explicit init double-inits them and triggers duplicate slide rendering.
        if (mediaThumbGroup != '' && !isV2){
          mediaThumbnailWrap.slick('unslick');
          mediaThumbnailWrap.css('visibility', 'hidden').empty();
          mediaThumbnailWrap.append(mediaThumbGroup);

          mediaThumbnailWrap
            .one('init', function() { $(this).css('visibility', 'visible'); })
            .slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            vertical:false,
            asNavFor: '.product__media-slider-' + productId,
            dots: false,
            arrows:true,
            focusOnSelect: true,
            infinite: true,
            draggable: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 4
                }
              }
            ]
          });
        }

        if (mediaSlideGroup != ''){
          mediaSliderWrap.slick('unslick');
          mediaSliderWrap.css('visibility', 'hidden').empty();
          mediaSliderWrap.append(mediaSlideGroup);

          // Programmatically populate each YouTube template's content after DOM insertion.
          // This avoids relying on jQuery's innerHTML parsing, which does not guarantee
          // that iframe content lands in template.content (causing the iframe to render).
          mediaSliderWrap[0].querySelectorAll('deferred-media[data-video-id]').forEach(function(el) {
            var videoId = el.getAttribute('data-video-id');
            var tmpl = el.querySelector('template');
            if (tmpl && videoId) {
              var iframe = document.createElement('iframe');
              iframe.setAttribute('frameborder', '0');
              iframe.setAttribute('allow', 'accelerometer; encrypted-media; gyroscope; picture-in-picture');
              iframe.setAttribute('allowfullscreen', 'allowfullscreen');
              iframe.setAttribute('class', 'js-youtube');
              iframe.setAttribute('loading', 'lazy');
              iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&controls=1&enablejsapi=1&loop=0&modestbranding=1');
              tmpl.content.appendChild(iframe);
            }
          });

          mediaSliderWrap
            .one('init', function() { $(this).css('visibility', 'visible'); })
            .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: isV2,
            arrows: isV2,
            asNavFor: isV2 ? null : '.product__media-thumbnails-' + productId,
            customPaging: function(slider, i) {
              return '<button type="button"></button>';
            }
          });
        }
      }

      //window.setTimeout(() => { document.querySelector('.product__media-slider').scrollIntoView({behavior: "smooth"}); });
    }
  
    function updateURL(target) {
      if (target.dataset.history === 'true'){
        window.history.replaceState({ }, '', `${target.dataset.url}?variant=${target.currentVariant.id}`);
      }
    }
  
    function updateVariantInput(target) {
      const productForms = document.querySelectorAll(`#product-form-${target.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = target.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    function updatePickupAvailability(target) {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      if (target.currentVariant && target.currentVariant.available) {
        pickUpAvailability.fetchAvailability(target.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    function removeErrorMessage(target) {
      const section = target.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    function renderProductInfo(target) {
      // Fetch the updated product information with the variant ID and section ID
      fetch(`${target.dataset.url}?variant=${target.currentVariant.id}&section_id=${target.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `price-${target.dataset.section}`;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
    
          // Update the price section with the new price
          if (source && destination) destination.innerHTML = source.innerHTML;
    
          // Show the price after it's updated (removing hidden class)
          const price = document.getElementById(`price-${target.dataset.section}`);
          if (price) price.classList.remove('visibility-hidden');
    
          // Update add-to-cart button based on availability
          toggleAddButton(target, !target.currentVariant.available, window.variantStrings.soldOut);
    
          // Handle "back in stock" notifications
          let backInstockVariations = document.querySelectorAll('[data-back-instock-variant-id]');
          backInstockVariations.forEach(el => {
            if (el.dataset.backInstockVariantId == target.currentVariant.id) {
              if (!target.currentVariant.available && el.classList.contains('backInStockHidden')) {
                el.classList.toggle('backInStockHidden');
                el.classList.toggle('backInStockActive');
              }
            } else if (el.classList.contains('backInStockActive')) {
              el.classList.toggle('backInStockHidden');
              el.classList.toggle('backInStockActive');
            }
          });
    
          // Reload the sale badge section dynamically
          const priceBadgeId = `price-badge-${target.dataset.section}`;
          const priceBadgeSource = html.getElementById(priceBadgeId);
          const priceBadgeDestination = document.getElementById(priceBadgeId);
    
          if (priceBadgeSource && priceBadgeDestination) {
            priceBadgeDestination.innerHTML = priceBadgeSource.innerHTML;
          }
    
          // Update inventory information if Shopify is managing inventory
          if (target.currentVariant.inventory_management === 'shopify' && window.inventories && window.inventories[target.dataset.productid]) {
            const variantInventoryObject = window.inventories[target.dataset.productid][target.currentVariant.id];
            const quantity = variantInventoryObject.quantity;
            const showInventory = quantity > 0;
            
            if (showInventory) {
              const quantityMessage = `In Stock - ${quantity} items`;
              // Update the stock level message
              if ($('.product-form__error-stock-level')) {
                $('.product-form__error-stock-level').text(quantityMessage);
              }
            }
          }
        });
    }
      
    
    function productImageZoom() {
      if ($(window).width() > 786) {
        $('.image-zoom').wrap('<span style="display:inline-block"></span>').css('display', 'block').parent().zoom({url: $(this).find('img').attr('data-zoom')});
      }
    }

    function toggleAddButton(target, disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${target.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        if (modifyClass) {
          addButton.setAttribute('disabled', true);
          addButton.removeAttribute('aria-disabled');
        } else {
          // Transient state while variant is resolving — keep button visible but non-interactive
          addButton.setAttribute('aria-disabled', 'true');
        }
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.removeAttribute('aria-disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    function setUnavailable(target) {
      const button = document.getElementById(`product-form-${target.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${target.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }

    function getVariantData(target) {
      target.variantData = target.variantData || JSON.parse(target.querySelector('[type="application/json"]').textContent);
      return target.variantData;
    }
  
    function updateRadioOptions(target) {
      const fieldsets = Array.from(target.querySelectorAll('fieldset'));
      target.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
    
    function updateEstimatedate(target) {
      var currentId = target.currentVariant.id;
      var productId = target.dataset.productid;
      var estimateBar = document.querySelector('.product__estimated-date');
      
      if(estimateBar && window.estimatedays && window.estimatedays[productId]){
        var estimateObject = window.estimatedays[productId][currentId];
        var estimatenow = estimateObject.nowSeconds;
        var estimatedatesec = estimateObject.esti_date_seconds;
        var estimatedate = estimateObject.esti_date;
        if(estimatedatesec > estimatenow){
          estimateBar.innerText = 'Estimated ship date ' + estimatedate;
        }else{
          estimateBar.innerText = '';
        }
      }
    }
  };
  
  theme.imageSlider = (function() {
    var namespace = '.image-slider--crack';
  
    function init() {
      $(namespace).slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: false,
        autoplay: false,
      	autoplaySpeed: 2000,
        slidesToShow: 1,
        adaptiveHeight: true
      });
    }
    
    return {
      init: init
    };
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var products = document.querySelectorAll('.grid--product');
  
    if (!products.length || !theme.settings.quickView) {
      return;
    }
  
    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
    });
  
    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };

  theme.faqCell = function(){
  	var faqCell = $('.faq-title');
    if(!faqCell) return;
    
    faqCell.on('click', function(){
      var faqList = $(this).closest('.faq-list');
      faqList.find('.faq-content').slideUp();
      $(this).toggleClass('active');
      $(this).parent().find('.faq-content').slideToggle();
    })
  };
  
  theme.preloadProductModal = function(handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = window.routes.home + '/products/' + handle + '?view=modal';
    var productDetailUrl = window.routes.home + '/products/' + handle;
  
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');
    productDetailUrl = productDetailUrl.replace("//", "/");
  
    fetch(url).then(function(response) {
      return response.text();
    }).then(function(html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product[data-product-handle="'+handle+'"]');
  
      if (!holder) {
        return;
      }
  
      holder.innerHTML = '';
      holder.append(div);

      // View All Details Modal Button
      var quickviewOptionMobileTest = document.querySelector(".quickview-option");
      if (quickviewOptionMobileTest) {
        var modalButtonContainer = holder.querySelector(".quickview-option .product-form");
        var detailsButton = document.createElement("a");
        var detailsButtonText = document.createTextNode("View All Details");
  
        detailsButton.appendChild(detailsButtonText);
        detailsButton.setAttribute("href", productDetailUrl);
        detailsButton.setAttribute(
            "class",
            "button button--full-width button--white"
        );
        modalButtonContainer.append(detailsButton);
      }
  
      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name, {
        productId: productId,
        handle: handle
      });      
    
      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }
  
  theme.productMediaSlide = function(handle, productId){
    if(!handle) return;
    var isV2 = $('body').hasClass('v2-template');
    var productMedia = $('.product[data-product-handle="'+handle+'"] .product__media-slider');
    var productThumbnail = $('.product[data-product-handle="'+handle+'"] .product__media-thumbnails');
    var variantSelect = $('.product-variant-radios-' + productId);
    var selectedOption = variantSelect.find('input[type="radio"]:checked');

	setTimeout(() => {

      if(productMedia){
        productMedia.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: isV2,
          arrows: isV2,
          asNavFor: isV2 ? null : '.product[data-product-handle="'+handle+'"] .product__media-thumbnails',
          customPaging: function(slider, i) {
            return '<button type="button"></button>';
          },
          responsive: [
            {
              breakpoint: 768,
              settings: {
                dots: isV2,
                arrows: isV2
              }
            }
          ]
        });
      }

      if(productThumbnail && !isV2){
        productThumbnail.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical:true,
          asNavFor: '.product[data-product-handle="'+handle+'"] .product__media-slider',
          dots: false,
          arrows:true,
          focusOnSelect: true,
          infinite: false,
          draggable: true
        });
      }

      if(selectedOption){
        $(selectedOption).trigger('click');
      }

    }, 300);
  }
 
  theme.blog = function(){
    $('body').on('click', '.pagination-load-more', function(e){
      e.preventDefault();
      var btn = $(this);
      btn.addClass('loading');
      btn.find('.loading-overlay__spinner').removeClass('hidden');
      var nextUrl = $(this).attr('href');
      var blogWrap = $('.blog-articles');
      var colWrap = $(this).closest('.collection').find('.product-grid');
      var paginationWrap = $(this).closest('.pagination-wrapper');
      
      fetch(nextUrl).then(function(response) {
        return response.text();
      }).then(function(html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var blogArticles = $(doc).find('.blog-articles').html();
        $(doc).find('.promo-card').addClass('promo-card--display-none');
        var colProducts = $(doc).find('#product-grid').html();
        var loadMoreLink = $(doc).find('.pagination-infinite');

        if(blogWrap) blogWrap.append(blogArticles);
        if(colWrap) colWrap.append(colProducts);
        if(loadMoreLink){
          paginationWrap.empty().append(loadMoreLink);
        }
        btn.removeClass('loading');
                
        yotpoWidgetsContainer.initWidgets();
        
        theme.initQuickShop();
      });
    })
  };

  theme.featuredColSlide = function(){
  	var featuredColSlide = $('.featured-col-slide');
    var autoSlide = featuredColSlide.data('auto');
    var enableDots = featuredColSlide.data('dots');
    var enableArrow = featuredColSlide.data('arrow');
    var desktopSize = featuredColSlide.data('slide-size-desktop');
    var mobileSize = featuredColSlide.data('slide-size-mobile');
    
    if(featuredColSlide){
      featuredColSlide.slick({
        slidesToShow: desktopSize,
        slidesToScroll: 1,
        infinite: true,
        dots: enableDots,
        arrows: enableArrow,
        autoplaySpeed: 3000,
        autoplay: autoSlide,
        responsive: [
          {
            breakpoint: 749,
            settings: {
              slidesToShow: mobileSize
            }
          }
        ]
      });
    }
  };

  theme.featuredSlide = function(){
  	var featuredSlides = $('.featured-slider');
    
    featuredSlides.each(function(){
      var featuredslide = $(this);
      var id = featuredslide.data('section');
      var selectedSlide = $('.featured-slider-' + id);
      var autoSlide = selectedSlide.data('auto');
      var enableDots = selectedSlide.data('dots');
      var enableArrow = selectedSlide.data('arrow');
      
      if(selectedSlide){
        selectedSlide.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: enableDots,
          arrows: enableArrow,
          autoplaySpeed: 3000,
          autoplay: autoSlide
        });
      }
    })
  };

  theme.videoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section',
      video: '.video-div'
    };

    function init(scope) {
      var el = scope ? scope : document;
      var dataDivs = el.querySelectorAll(selectors.video);

      if (!dataDivs) {
        return;
      }

      dataDivs.forEach(trigger => {
        var videoObject;
        var type = trigger.dataset.type;
        var parentElement = trigger.closest(selectors.videoParent);
        var sectionId = parentElement.dataset.sectionid;

        switch(type) {
          case 'youtube':
            var videoId = trigger.dataset.videoId;
            initYoutubeVideo(videoId, sectionId, videoObject);
            break;
          case 'vimeo':
            var videoId = trigger.dataset.videoId;
            initVimeoVideo(videoId, sectionId, videoObject);
            break;
          case 'mp4':
            initMp4Video(parentElement, sectionId, videoObject);
            break;
        }  
      });

    }

    function initYoutubeVideo(videoId, sectionId, videoObject){
      videoObject = new theme.YouTube(
        'YouTubeVideo-' + sectionId,
        {
          videoId: videoId,
          videoParent: selectors.videoParent
        }
      );
    }

    function initVimeoVideo(videoId, sectionId, videoObject) {
      videoObject = new theme.VimeoPlayer(
        'Vimeo-' + sectionId,
        videoId,
        {
          videoParent: selectors.videoParent
        }
      );
    }

    function initMp4Video(parentElement, sectionId, videoObject) {
      var mp4Video = 'Mp4Video-' + sectionId;
      var mp4Div = document.getElementById(mp4Video);
      var parent = parentElement;

      if (mp4Div) {
        parent.classList.add('loaded');

        var playPromise = document.querySelector('#' + mp4Video).play();

        // Edge does not return a promise (video still plays)
        if (playPromise !== undefined) {
          playPromise.then(function() {
              // playback normal
            }).catch(function() {
              // mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
            });
        }
      }
    }
    return {
      init: init
    };
  })();
  
  theme.variantSelecter();
  theme.imageSlider.init();
  theme.initQuickShop();
  theme.faqCell();
  theme.blog();
  theme.featuredColSlide();
  theme.featuredSlide();
  theme.videoSection.init();
  
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus?.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    } else {
      // TODO: Refactor this to work correctly - openMenuDrawer should note the trap focus element and it should work with filter drawer open event
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;


    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      this.querySelector('button').addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.target);
      });
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', () => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('overflow-hidden');
      trapFocus(this);
    }
  });
}

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);


class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }


    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const cartQuantity = document.querySelectorAll('.js-header__cart-quantity');
        cartQuantity.forEach((item) => item.innerHTML = parsedState.item_count);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

	document.dispatchEvent(new CustomEvent('cartNotification'));

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      // this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        // sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        // sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          fetch('/cart.js')
            .then((response) => response.json())
            .then((response) => {
              const cartQuantity = document.querySelectorAll('.js-header__cart-quantity');
              cartQuantity.forEach((item) => item.innerHTML = response.item_count);
            });

          // this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        //this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

customElements.define('product-modal', ProductModal);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            theme.initQuickShop();
            var api = new Yotpo.API(yotpo);
            api.refreshWidgets();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');

  return (msie > 0 || trident > 0);
}

theme.colorSwatches = (function() {
  var hasBoundEvents = false;

  function setActiveSwatch($swatch) {
    var $group = $swatch.closest('.card-information__color-swatches');
    $group.find('.card-color-swatch').not($swatch).removeClass('js--is-active').attr({'aria-pressed': 'false'});
    $swatch.addClass('js--is-active').attr({'aria-pressed': 'true'});
  }

  function toggleSaleBadge($swatch) {
    var $cardWrapper = $swatch.closest('.card-wrapper');
    var $saleBadge = $cardWrapper.find('.card__badge .badge.color-sale');

    var onSaleData = $swatch.data('swatch-on-sale');
    var newColorData = $swatch.data('swatch-new-color');
    var isOnSale = onSaleData === true || onSaleData === 'true';
    var isNewColor = newColorData === true || newColorData === 'true';

    $cardWrapper.attr('data-active-variant-on-sale', isOnSale ? 'true' : 'false');
    $cardWrapper.attr('data-active-variant-new-color', isNewColor ? 'true' : 'false');

    if (!$saleBadge.length) return;

    if (isOnSale) {
      $saleBadge.attr('data-sale-badge-visible', 'true');
    } else {
      $saleBadge.attr('data-sale-badge-visible', 'false');
    }
  }

  function getDefaultSwatch($cardWrapper) {
    var $swatches = $cardWrapper.find('.card-color-swatch');
    var $active = $swatches.filter('.js--is-active');
    return $active.length ? $active.first() : $swatches.first();
  }

  function swapMedia($swatch) {
    var newimage = $swatch.data('img-url'),
      mimg = $swatch.data('mimg'),
      newurl = $swatch.data('url'),
      varid = $swatch.data('varid'),
      variantAlt = $swatch.data('variant-alt');

    setActiveSwatch($swatch);

    if (mimg) {
      var $media = $(mimg);
      $media.removeAttr('srcset');
      if (newimage) {
        $media.attr('src', newimage);
      }
      if (variantAlt) {
        $media.attr('alt', variantAlt);
      }
    }

    var $cardWrapper = $swatch.closest('.card-wrapper');
    if (newurl) {
      var url = newurl;
      if (varid) {
        url = newurl + '?variant=' + varid;
      }
      $cardWrapper.addClass('color-swatch-active');
      $cardWrapper.data('url', url);
    }
  }

  function handlePreview(event) {
    var $swatch = $(event.currentTarget);
    swapMedia($swatch);
    toggleSaleBadge($swatch);
  }

  function handleMouseOut(event) {
    var $swatch = $(event.currentTarget);
    var $cardWrapper = $swatch.closest('.card-wrapper');
    var $defaultSwatch = getDefaultSwatch($cardWrapper);
    if ($defaultSwatch.length) {
      toggleSaleBadge($defaultSwatch);
    }
  }

  function handleActivate(event) {
    var isKeyboardActivate = event.type === 'keydown';
    var key = event.key;

    if (isKeyboardActivate && key !== 'Enter' && key !== ' ' && key !== 'Spacebar') {
      return;
    }
    if (isKeyboardActivate) {
      event.preventDefault();
    }
    event.stopPropagation();
    var $swatch = $(event.currentTarget);
    swapMedia($swatch);
    toggleSaleBadge($swatch);
  }

  function handleCardNavigation(event) {
    var newurl = $(event.currentTarget).data('url');
    if (newurl) {
      window.location.href = newurl;
    }
  }

  function initSaleBadgeState() {
    $('.card-wrapper').each(function() {
      var $cardWrapper = $(this);
      var $swatches = $cardWrapper.find('.card-information__color-swatches');
      
      // Only initialize if card has swatches
      if ($swatches.length) {
        var $defaultSwatch = getDefaultSwatch($cardWrapper);
        if ($defaultSwatch.length) {
          toggleSaleBadge($defaultSwatch);
        }
      }
    });
  }

  function bindEvents() {
    if (hasBoundEvents) return;

    hasBoundEvents = true;
    var $body = $('body');
    $body.on('mouseover focus', '.card-color-swatch', handlePreview);
    $body.on('mouseout blur', '.card-color-swatch', handleMouseOut);
    $body.on('mouseover focusin', '.card-color-swatch', handlePreview);
    $body.on('click keydown', '.card-color-swatch', handleActivate);
    $body.on('click', '.card-wrapper', handleCardNavigation);
  }

  return {
    init: bindEvents,
    initSaleBadgeState: initSaleBadgeState
  };
})();

theme.colorSwatches.init();

// Initialize sale badge state on page load
$(document).ready(function() {
  theme.colorSwatches.initSaleBadgeState();
});

// sections/footer.liquid
$(document).ready(function(){
  if($(window).width() < 750){
    $('.footer-block__heading').on('click', function(){
      $(this).toggleClass('active');
      // $(this).next().slideToggle();
    })
  }

    var $readMoreContainers = $('.read-more__container');

    $readMoreContainers.each(function(){
        var $readMoreWrapper = $(this).find('.read-more__wrapper');
        var $readMoreWrapperHeight = $readMoreWrapper.height();
        var $readMoreCta = $(this).find('.read-more__cta');

        if($readMoreWrapperHeight >= 96){
            $(this).removeClass('read-more__container--expand');
        }else {
            $readMoreCta.hide();
            $(this).addClass('read-more__container--expand');
        }
    });

    $('.read-more__cta').on('click', function(e){
        var $readMoreContainer = $(this).closest('.read-more__container');
        $readMoreContainer.toggleClass('read-more__container--expand');
        $readMoreContainer.attr('aria-expanded', function (i, attr) {
          return attr == 'true' ? 'false' : 'true'
      });
    });

    $('.read-more__cta').on('keypress', function(e) {
      e.preventDefault();
      if(e.which == 13) {
        var $readMoreContainer = $(this).closest('.read-more__container');
        $readMoreContainer.toggleClass('read-more__container--expand');
        $readMoreContainer.attr('aria-expanded', function (i, attr) {
          return attr == 'true' ? 'false' : 'true'
        });
      }
    });

    // Function to handle the scroll event with hysteresis to prevent flicker.
    // Show bar when ATC is 100px above viewport; keep it shown until it's only
    // 30px above — the gap between thresholds prevents rapid toggling at the boundary.
    var stickyBarVisible = false;
    var stickyScrollTicking = false;

    function handleScroll() {
      if (stickyScrollTicking) return;
      stickyScrollTicking = true;

      requestAnimationFrame(function() {
        var targetElement = document.querySelector('.product-form__container');

        if (targetElement !== null) {
          var rect = targetElement.getBoundingClientRect();
          if (!stickyBarVisible && rect.bottom < -100) {
            stickyBarVisible = true;
            targetElement.classList.add('product__sticky--show');
            targetElement.classList.remove('product__sticky--hide');
          } else if (stickyBarVisible && rect.bottom > -30) {
            stickyBarVisible = false;
            targetElement.classList.add('product__sticky--hide');
            targetElement.classList.remove('product__sticky--show');
          }
        }

        stickyScrollTicking = false;
      });
    }

    // Attach the handleScroll function to the scroll event
    window.addEventListener('scroll', handleScroll);

    // Initial check in case the element is already in the viewport on page load
    handleScroll();
})

document.addEventListener('DOMContentLoaded', function () {
  const blundleProducts = document.querySelectorAll('.product-form__input--bundle');

  if (blundleProducts.length > 0) {
    blundleProducts.forEach(bundleProduct => {
      const radios = bundleProduct.querySelectorAll('.product-form__option-values input');
      const thumbnail = bundleProduct.querySelector('.bundle-thumbnail img');

      if (radios.length > 0 && thumbnail) {
        radios.forEach(radio => {
          radio.addEventListener('change', function () {
            if (this.checked) {
              thumbnail.src = this.getAttribute('data-img-url');
              thumbnail.srcset = this.getAttribute('data-img-url');
              thumbnail.alt = this.getAttribute('data-variant-alt');
            }
          });
        });
      }
    });
  }

  const swatchGroups = document.querySelectorAll('.product-form__option-values[role="radiogroup"]');

  swatchGroups.forEach((group) => {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;

    const labels = radios.map((radio) => group.querySelector(`label[for="${radio.id}"]`));

    const syncState = () => {
      let activeIndex = radios.findIndex((radio) => radio.checked && !radio.disabled);
      if (activeIndex < 0) activeIndex = 0;

      radios.forEach((radio, index) => {
        const label = labels[index];
        if (!label) return;
        const isChecked = radio.checked;
        label.setAttribute('aria-checked', isChecked ? 'true' : 'false');
        label.setAttribute('tabindex', index === activeIndex ? '0' : '-1');
      });
    };

    const setChecked = (index) => {
      const radio = radios[index];
      if (!radio || radio.disabled) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      const label = labels[index];
      if (label) {
        label.focus();
      }
      syncState();
    };

    labels.forEach((label, index) => {
      if (!label) return;

      label.addEventListener('keydown', (event) => {
        const key = event.key;
        if (key === ' ' || key === 'Enter') {
          event.preventDefault();
          setChecked(index);
        }

        if (key === 'ArrowRight' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowUp') {
          event.preventDefault();
          const change = key === 'ArrowRight' || key === 'ArrowDown' ? 1 : -1;
          const nextIndex = (index + change + radios.length) % radios.length;
          setChecked(nextIndex);
        }
      });

      const radio = radios[index];
      if (radio) {
        radio.addEventListener('change', syncState);
      }
    });

    syncState();
  });

  const sizeGroups = document.querySelectorAll('.sizes__list[role="radiogroup"]');

  sizeGroups.forEach((group) => {
    const radios = Array.from(group.querySelectorAll('[role="radio"]'));
    if (!radios.length) return;

    const syncState = () => {
      let activeIndex = radios.findIndex((item) => item.getAttribute('aria-checked') === 'true');
      if (activeIndex < 0) activeIndex = 0;

      radios.forEach((item, index) => {
        item.setAttribute('tabindex', index === activeIndex ? '0' : '-1');
      });
    };

    const setChecked = (index) => {
      const target = radios[index];
      if (!target) return;

      radios.forEach((item, idx) => {
        item.setAttribute('aria-checked', idx === index ? 'true' : 'false');
      });

      target.focus();
      target.click();
      syncState();
    };

    radios.forEach((item, index) => {
      item.addEventListener('keydown', (event) => {
        const key = event.key;

        if (key === ' ' || key === 'Enter') {
          event.preventDefault();
          setChecked(index);
        }

        if (key === 'ArrowRight' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowUp') {
          event.preventDefault();
          const change = key === 'ArrowRight' || key === 'ArrowDown' ? 1 : -1;
          const nextIndex = (index + change + radios.length) % radios.length;
          setChecked(nextIndex);
        }
      });
    });

    syncState();
  });
});
class searchToggle extends HTMLElement {
    constructor() {
        super();
        this.searchToggleButton = this.querySelector('#search__toggle');
        this.searchContentContainer = this.querySelector('#search-content__container');
        this.searchCloseButton = this.querySelector('#search__close-button');
    this.openedByPointer = false;

    this.onSearchKeydown = (event) => {
      if (event.key === 'Tab') {
        document.documentElement.classList.add('tab-outline');
        this.searchContentContainer.classList.add('search--keyboard-focus');
      }
    };

    this.onTogglePointerDown = () => {
      this.openedByPointer = true;
      this.searchContentContainer.classList.remove('search--keyboard-focus');
    };

    this.onSearchPointerDown = () => {
      this.searchContentContainer.classList.remove('search--keyboard-focus');
    };

        this.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );
        this.searchToggleButton.addEventListener(
            'click',
            this.toggleSearch.bind(this)
        );
        this.searchToggleButton.addEventListener('pointerdown', this.onTogglePointerDown);
        this.searchCloseButton.addEventListener(
            'click',
          () => this.close(false)
        );

        // Initialize onBodyClickEvent
        this.onBodyClickEvent = this.onBodyClick.bind(this);
    }

    toggleSearch(event) {
        event.preventDefault();
        const $this = event.target.closest('#search__toggle');
        $this.getAttribute('aria-expanded') === 'true'
            ? this.close()
            : this.open(event);
    }

    onBodyClick(event) {
        if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
    }

    open(event) {
        const $this = event.target.closest('#search__toggle');
        const focusableElements = this.searchContentContainer.querySelectorAll('button[tabindex="-1"], input[tabindex="-1"]');

        $this.setAttribute('aria-expanded', 'true');
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add('overflow-hidden');
      this.openedByPointer = false;

      this.searchContentContainer.classList.remove('search--keyboard-focus');
      this.searchContentContainer.addEventListener('keydown', this.onSearchKeydown);
      this.searchContentContainer.addEventListener('pointerdown', this.onSearchPointerDown);

        // Enable focus when opening
        focusableElements.forEach(element => {
            element.setAttribute('tabindex', '0');
        });

        trapFocus(
            this.searchContentContainer.querySelector('[tabindex="-1"]'),
            this.searchContentContainer.querySelector('input:not([type="hidden"])')
        );
    }

    close(focusToggle = true) {
        const removeFocusableElements = this.searchContentContainer.querySelectorAll('button[tabindex="0"], input[tabindex="0"]');
        // Focusable Elements to remove when closing
        removeFocusableElements.forEach(element => {
            element.setAttribute('tabindex', '-1');
        });

      this.searchContentContainer.classList.remove('search--keyboard-focus');
      this.searchContentContainer.removeEventListener('keydown', this.onSearchKeydown);
      this.searchContentContainer.removeEventListener('pointerdown', this.onSearchPointerDown);

        removeTrapFocus(focusToggle ? this.searchToggleButton : null);
        this.searchToggleButton.setAttribute('aria-expanded', 'false');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');

      if (!document.documentElement.classList.contains('tab-outline')) {
        this.searchToggleButton.blur();
      }
    }
}

customElements.define('search-toggle', searchToggle);

    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
